module.exports = __webpack_public_path__ + "static/media/logo-convert.23fc8dfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/logo-convert.png
// module id = 1327
// module chunks = 0